var translations = {
    de: {
        title: 'Bitte haben Sie einen Moment Geduld.',
        content: 'Die Übertragung Ihrer Angaben erfolgt über einen Sicherheitsserver.',
    },
};
export default translations;
